/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Metadata_Scan_TitleInputs */



/**
* | output |
* | --- |
* | "Metadata Scan" |
*
* @param {Player_Metadata_Scan_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_metadata_scan_title = /** @type {((inputs?: Player_Metadata_Scan_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Metadata_Scan_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Analyse des Metadonnees")
	if (locale === "de") return /** @type {LocalizedString} */ ("Metadaten-Scan")
	if (locale === "it") return /** @type {LocalizedString} */ ("Scansione dei metadati")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сканирование метаданных")
	if (locale === "es") return /** @type {LocalizedString} */ ("Escaneo de metadatos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("元数据扫描")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メタデータスキャン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मेटाडेटा स्कैन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Análise de Metadados")
	return /** @type {LocalizedString} */ ("Metadata Scan")
});